import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MODAL_SMALL_SIZE } from '../helper';
import {
    POPUP_KEY_ADD_INGREDIENT_TO_RECIPE,
    RECIPE_INGREDIENT_TYPE_CEREAL_MIX,
    RECIPE_INGREDIENT_TYPE_PRODUCT,
} from '../../constant';
import { useTranslation } from 'react-i18next';
import IngredientHandler from './IngredientHandler';
import IngredientTypeSwitcher from './IngredientTypeSwitcher';
import Modal from '../Modal';
import { popupOpenService } from '../../shared/popupOpenService';
import { recipeAddIngredientService } from '../../services/recipeAddIngredientsService';
import { productsStorage } from '../../services/productsStorage';
import { recipeSaveService } from '../../services/recipeSaveService';
import { preferenceCerealMixSelectService, prepareProductCodes } from '../../services/preferenceCerealMixSelectService';
import { Button } from '@chapche/ui';

const AddIngredientModalContent = ({handleClick, handleClose, changeIngredientType}) => {
    const { i18n } = useTranslation();
    return (
        <div className="recipe__modal">
            <h2 className="modal__title modal__title_align block__title-h3 recipe__ingredient-title ">{i18n.t('app.page.recipe.modal.addIngredient.title')}</h2>
            <IngredientTypeSwitcher changeIngredientType={changeIngredientType}/>
            <label className="block__text recipe__form-label recipe__form-modal" >
                <span className="product__form-label_text">
                    {recipeAddIngredientService.getIngredientType() === RECIPE_INGREDIENT_TYPE_CEREAL_MIX ?
                        i18n.t('preference.scheme.preferenceType.cereal-mix')
                        : 
                        i18n.t('app.page.recipe.product')}
                </span>
                <IngredientHandler selectWithTokensManager={recipeAddIngredientService} /> 
            </label>
            <div className="modal__button-group">
                <Button variant="outline" onClick={handleClose}>
                    {i18n.t('app.page.recipe.modal.cancel')}
                </Button>
                <Button disabled={!handleClick} onClick={handleClick}>
                    {i18n.t('app.page.recipe.modal.addModal.add')}
                </Button>
            </div>
        </div>
    );
};

const AddNewIngredientPopup = () => {
    const [isVisible, setIsVisible] = useState('');
    const [ingredient, setIngredient] = useState({});
    const [searchParams] = useSearchParams();
    const ingredientTab = searchParams.get('ingredientTab');
    const ingredientTabRef = useRef(ingredientTab);
    ingredientTabRef.current = ingredientTab;

    const changePopupVisibility = () => {
        recipeAddIngredientService.setIngredientGroup(ingredientTabRef.current);
        setIsVisible(true);
    };

    const closePopup = () => {
        setIsVisible(false);
        recipeAddIngredientService.deleteItem('', true);
        recipeAddIngredientService.changeIngredientType(RECIPE_INGREDIENT_TYPE_PRODUCT);
        recipeAddIngredientService.setSearchFilterValue('');
        recipeAddIngredientService.setIngredientGroup('');
        preferenceCerealMixSelectService.setSearchFilterValue('');
    };

    useEffect(() => {
        popupOpenService.registerPopup(POPUP_KEY_ADD_INGREDIENT_TO_RECIPE, changePopupVisibility);
        return () => popupOpenService.unRegisterPopup(POPUP_KEY_ADD_INGREDIENT_TO_RECIPE, changePopupVisibility);
    }, []);

    const changeIngredientType = (value) => {
        setIngredient({...ingredient, ingredientType: value});
        recipeAddIngredientService.changeIngredientType(value);
    };

    const saveIngredient = () => {
        if(recipeAddIngredientService.getCurrentItems() && recipeAddIngredientService.getCurrentItems().length) {
            if(ingredient.ingredientType === RECIPE_INGREDIENT_TYPE_CEREAL_MIX) {
                const preparedData = {
                    ingredientType: RECIPE_INGREDIENT_TYPE_CEREAL_MIX,
                    ingredientGroup: ingredientTab,
                    ingredientParts: prepareProductCodes(recipeAddIngredientService.getCurrentItems()),
                };
                recipeSaveService.addIngredient(preparedData);
                recipeAddIngredientService.deleteItem('', true);
            } else {
                for(let ingredientData of recipeAddIngredientService.getCurrentItems()) {
                    const preparedData = {
                        ingredientType: ingredient.ingredientType ? ingredient.ingredientType : RECIPE_INGREDIENT_TYPE_PRODUCT,
                        ingredientGroup: ingredientTab,
                        ingredientParts: [{
                            productCode: productsStorage.getById(ingredientData.itemId).productCode,
                            ingredientForms: [],
                        }],
                    };
                    recipeSaveService.addIngredient(preparedData);
                    recipeAddIngredientService.deleteItem('', true);
                }
            }
            setIsVisible(false);
        }
    };

    return (
        isVisible ?
            <Modal handleCloseModal={closePopup} size={MODAL_SMALL_SIZE}
                content={<AddIngredientModalContent handleClose={closePopup} changeIngredientType={changeIngredientType} handleClick={saveIngredient}/>} 
            />
            :
            null
    );
};

export default AddNewIngredientPopup;
